import { VemioApi } from './../../../services/api/vemio-api.service';
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription }                 from "rxjs";
import { PopupVisibility }              from "../../../@models/core";

@Component({
	selector: 'kkb-tur-debug-panel',
	templateUrl: './tur-debug-panel.component.html',
	styleUrls: ['./tur-debug-panel.component.scss', '../../../pages/tur/tur.scss']
})
export class TurDebugPanelComponent implements OnInit, OnDestroy {

	visibility: PopupVisibility = '';
	sensors: string[][] = [];

	private requestOpenTimer = 0;
	private listener: Subscription;
	private sensorTimer = 0;


	constructor(private vemioApi: VemioApi) {
	}

	open() {
		this.visibility = 'popupVisible';
	}

	close() {
		this.visibility = 'popupHidden';
	}

	startRequestOpen() {
		this.requestOpenTimer = window.setTimeout(() => {
			clearTimeout(this.requestOpenTimer);
			this.requestOpenTimer = 0;
			this.open();
		}, 3000);
	}

	cancelRequestOpen() {
		if (this.requestOpenTimer !== 0) {
			clearTimeout(this.requestOpenTimer);
			this.requestOpenTimer = 0;
		}
	}

	reloadApp() {
		location.reload();
	}

	ngOnInit() {
		this.sensorTimer = window.setInterval(async () => {
			if (this.visibility !== 'popupVisible')
				return;
			const sensorvalues = await this.vemioApi.getSensorValues();
			if (sensorvalues) {
				const sensorIDs = Object.keys(sensorvalues).sort();
				if (sensorIDs) {
					this.sensors = [];
					sensorIDs.forEach(key => this.sensors.push([key, sensorvalues[key]]));
				}
			}
		}, 500);
	}

	ngOnDestroy() {
		this.cancelRequestOpen();
		if (this.sensorTimer)
			clearInterval(this.sensorTimer);
	}

}
